import React, { ChangeEvent, FormEvent, useState } from 'react';
import { baseUrl } from '../library/comoda';

const Upload: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [category, setCategory] = useState<'Film' | 'Musica' | 'Serie'>('Film');
  const [msg, setMsg] = useState<string>('');
  const [busy, setBusy] = useState<boolean>(false);

  /* handler tipizzati */
  const onFile = (e: ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0] || null;
    if (f && f.name.endsWith('.zip')) {
      setFile(f);
      setMsg('');
    } else {
      setMsg('Seleziona uno .zip valido');
    }
  };

  const onRadio = (e: ChangeEvent<HTMLInputElement>) =>
    setCategory(e.target.value as 'Film' | 'Musica' | 'Serie');

  const onSend = async (e: FormEvent) => {
    e.preventDefault();
    if (!file) return setMsg('Nessun file');
    setBusy(true);

    const body = new FormData();
    body.append('file', file);
    body.append('category', category);

    try {
      const r = await fetch(`${baseUrl}/upload.php`, { method: 'POST', body });
      const j = await r.json();
      setMsg(j.status === 'success' ? 'Upload OK' : j.message || 'Errore');
    } catch {
      setMsg('Errore durante upload');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="box background">
        <h2 className="title">Upload File</h2>

<p>Consente l'upload di un file .zip, contenente Film, Musica o Serie TV.</p>
<p><b>Attenzione:</b> caricare <u>solo</u> file .zip e selezionare correttamente la tipologia.</p>
<p>In caso di errori chiedere al Davide.</p>

        <form onSubmit={onSend}>
          <div className="radio-group">
            {(['Film', 'Musica', 'Serie'] as const).map(v => (
              <React.Fragment key={v}>
                <input
                  type="radio"
                  id={v}
                  name="category"
                  value={v}
                  checked={category === v}
                  onChange={onRadio}
                  disabled={busy}
                />
                <label htmlFor={v}>{v}</label>
              </React.Fragment>
            ))}
          </div>

         
          <div className='center'>
          <input
            type="file"
            accept=".zip"
            onChange={onFile}
            disabled={busy}
            style={{ marginTop: 20 }}
          />
          <button type="submit" className="btn margin" disabled={busy} style={{ marginTop: 20 }}>
            {busy ? 'Uploading…' : 'Upload'}
          </button>
          </div>
        </form>

        {msg && <p className="errore" style={{ marginTop: 40 }}>{"ATTENZIONE: "+msg}</p>}
      </div>
  );
};

export default Upload;
